import React, { FC } from 'react';
import styles from '../StoreReadyStep.scss';
import { Button } from '@wix/design-system';
import { Trans, useTranslation } from '@wix/wix-i18n-config';
import { biEvents } from 'api/bi-events';
import { useOrchestratorNavigation } from '@wix/gg-components/orchestrator';
import { BI_BUTTON_NAME, BI_STEP_NAME } from 'config/bi';
import { StepId } from 'config/steps';
import { StoreReadyStepActions } from './StoreReadyStepActions';
import { TextDivider } from 'components/TextDivider/TextDivider';

export const StoreReadyStepContent: FC = () => {
  const { t } = useTranslation();
  const { next } = useOrchestratorNavigation();

  const handleNext = () => {
    biEvents.actionClicked({
      screenName: BI_STEP_NAME[StepId.StoreReady],
      button_name: BI_BUTTON_NAME.START_SELLING,
    });
    next();
  };

  return (
    <div className={styles.storeReadyStepContent}>
      <div className={styles.storeReadyStepContentTypography}>
        <p className={styles.storeReadyStepContentTitle}>
          <Trans i18nKey="store-ready-step.content.title" components={{ br: <br /> }} />
        </p>
        <p className={styles.storeReadyStepContentDescription}>{t('store-ready-step.content.description')}</p>
      </div>
      <Button size="large" skin="dark" onClick={handleNext}>
        {t('store-ready-step.content.primary-button')}
      </Button>
      <TextDivider text={t('store-ready-step.content.divider')} />
      <StoreReadyStepActions />
    </div>
  );
};
